import { CrudManager, useConfig } from "./crud";

const columns = [
  { key: "name", label: "Marca" },
  { key: "status", label: "Estado" },
  { key: "order", label: "Orden" },
  { key: "active", label: "Visible" },
];

export default function BrandsAdmin() {
  const config = useConfig();
  if (!config) return null;
  const fields = [
    { key: "name", label: "Nombre", type: "text" },
    { key: "description", label: "Descripción", type: "i18n-textarea" },
    { key: "logo", label: "Logo", type: "media" },
    { key: "image", label: "Imagen", type: "media" },
    { key: "url", label: "URL", type: "text" },
    { key: "status", label: "Estado", type: "select", options: config.brand_statuses || [] },
    { key: "logo_only", label: "Solo logo (ocultar nombre)", type: "switch" },
    { key: "order", label: "Orden", type: "number" },
    { key: "active", label: "Visible", type: "switch" },
  ];
  return <CrudManager coll="brands" title="Ecosistema de Marcas" fields={fields} columns={columns} testid="brands-admin" />;
}
